export default __webpack_public_path__ + "static/media/section1-measure2.4393c6fb.svg";